import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '@s/Dropdown';
import Button from 'shared/Button';
import styled from 'styled-components';

class TicketCount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingCount: false,
            count: 0,
            ticketResetLoading: false,
            id: null,
        }
    }

    componentDidMount() {
        if(this.props.user) {
            this.fetchTicketCount();
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.user !== this.props.user) {
            this.fetchTicketCount();
        }
    }

    fetchTicketCount = () => {
        this.setState({loadingCount: true});
        let req = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        }

        return fetch(this.props.apiUrl + '/kiosks/' + this.props.user + '/ticket-count', req).then((res) => {
            this.setState({loadingCount: false});
            if(res.status === 200) {
                return res.json();
            }
        }).then((res) => {
            this.setState({count: res.count, id: res.id});
        }).catch((e) => {});
    }

    render() {
        return(
            <TicketCouterContainer className="ticket-counter__container">
                    <TicketCouterLabel className="ticket-counter__label">Tickets Printed</TicketCouterLabel>
                    <TicketCouterList className="ticket-counter__list card">
                        <strong>
                            {this.state.loadingCount ? "Loading..." : this.state.count}
                        </strong>
                        <Button className="button button--link" onClick={this.resetTicketTime} disabled={this.state.ticketResetLoading}>Reset Counter</Button>
                    </TicketCouterList>
            </TicketCouterContainer>
        )
    }

    resetTicketTime = () => {
        if(!this.state.id) {
            return;
        }

        this.setState({ticketResetLoading: true});
        let req = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({statusId: this.state.id}),
        }

        return fetch(this.props.apiUrl + '/kiosks/ticket-reset', req).then((res) => {
            this.setState({ticketResetLoading: false});
            if(res.status === 200) {
                return res.json();
            }
        }).then((res) => {
            this.fetchTicketCount();
        }).catch((e) => {});
    }
}

TicketCount.propTypes = {
    apiUrl: PropTypes.string.isRequired,
}

TicketCount.defaultProps = {
}

export default TicketCount;

const TicketCouterContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0px 30px 20px;
    margin-bottom: 85px;
    // border-top: 1px solid #eeeeee;
    // min-height: 200px; //remove after fixing bottom button bug
`
const TicketCouterLabel = styled.div`
    width: 150px;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
`
const TicketCouterList = styled.div`
    font-size: 15px;
    padding: 11px 16px 14px;
`